@defer (on viewport; hydrate on immediate) {
	<div data-test-id="event-overview">
		@for (blok of contentInputs(); track $index) {
			@if (components) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok['component']]"
					[ndcDynamicInputs]="blok"
				/>
			}
		}
	</div>
	<section
		[ngClass]="'gradient-160px' | sectionBgClass"
		class="section-spacing"
	>
		<div
			class="section-inner section-gap children:w-full children:md:mx-auto"
		></div>
	</section>
} @placeholder {
	<vp-skeleton />
}
